import React, { useEffect, useState } from "react";
import styles from "./FAQ.module.css";
import { BiSolidRightArrow } from "react-icons/bi";
import Aos from "aos";
import "aos/dist/aos.css";

const FAQ = ({ data }) => {
  const [selectedQues, setSelectedQues] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleQuesClick = (index) => {
    const selected = data[index];
    setSelectedIndex(index);
    setSelectedQues(selected);
  };

  useEffect(() => {
    setSelectedQues(data[selectedIndex]);
    Aos.init({ duration: 1500 });
  }, [data, selectedIndex]);

  return (
    <div className={styles.FAQPage}>
      <div className={styles.inncerCon}>
        <h3>FAQ</h3>
        <section className={styles.flex_con}>
          {/* Left side — questions */}
          <div className={styles.faq_questionCon}>
            {data.map((item, index) => {
              const isSelected = index === selectedIndex;
              return (
                <div
                  key={index}
                  className={`${styles.faqQuestion} ${isSelected ? styles.active : ""}`}
                  onClick={() => handleQuesClick(index)}
                >
                  <BiSolidRightArrow
                    className={styles.arrowIcon}
                    style={{
                      transform: isSelected ? "scale(1)" : "scale(0)",
                      opacity: isSelected ? 1 : 0,
                      transition: "all 0.3s ease",
                    }}
                  />
                  <p style={{ color: isSelected ? "#77D5FF" : "" }}>
                    {item.question}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Right side — answers */}
          <div className={styles.rightCon} data-aos="fade-up">
            <div className={styles.backgroundRec}></div>
            <div className={styles.AnswerCon}>
              <h4>{selectedQues?.question}</h4>

              {/* ✅ Render based on answer type */}
              {typeof selectedQues?.answer === "string" ? (
                <p>{selectedQues?.answer}</p>
              ) : (
                <div className={styles.answerObject}>
                  <p className={styles.answerTitle}>{selectedQues?.answer?.title}</p>
                  <ul className={styles.answerList}>
                    {selectedQues?.answer?.list?.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FAQ;
